import React, { useEffect, useState, useMemo } from 'react';
import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import AnoCard from './balanceteAnoCard';

const Balancetes = (params) => {
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/demonstrativos`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = () => {
      fetch(url, {
        method: 'GET',
        headers: requestHeaders
        })
        .then((response) => response.json())
        .then((result) => {
          setPages(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);

  return (
    <div>
        {isLoading
          ?
            <Skeleton sx={{ bgcolor: 'rgba(255, 255, 255, 0.5)' }} variant="rectangular" width={210} height={25} animation="wave" className="skeleton_FE"/>
          :
            <Box className="transparencia_list">
            {Object.entries(pages).reverse().map(([key, value]) => (
              <Card className="transparencia_card" key={key}>
                <AnoCard ano={key} dados={value}/>
              </Card>
            ))}
          </Box>
        }
    </div>
  );
};

export default Balancetes;

